<template>
  <v-dialog :model-value="dialog" @update:model-value="$emit('update:dialog', $event)" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5">Crear un/a {{ project.subprojectName || 'subproyecto' }}</span>
        <v-btn icon @click="closeWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field v-model="subprojectName" :label="`Nombre del ${project.subprojectName || 'subproyecto'}`"
            required></v-text-field>

          <v-select v-model="selectedInvitados" :items="project.userMembers" label="Selecciona los invitados" multiple
            chips></v-select>
          
          <!-- Seleccionar encargado -->
          <v-select v-model="selectedEncargado" :items="project.userMembers" label="Selecciona el encargado (Se utilizará para la foto del proyecto)"
            chips></v-select>

        </v-form>
      </v-card-text>

      <!-- Botón para crear -->
      <v-card-actions>
        <v-btn text @click="closeWindow">Cancelar</v-btn>
        <v-btn color="primary" @click="send">Crear {{ project.subprojectName || 'subproyecto' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';

export default {
  name: "NewSubprojectComponent",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
  },
  data() {
    return {
      subprojectName: "",
      selectedInvitados: [],
      selectedEncargado: null, // Encargado seleccionado
    };
  },
  methods: {
    closeWindow() {
      this.$emit("update:dialog", false);
    },
    async send() {
      // Clonar proyecto
      const subproject = { ...this.project };

      // Reemplazar atributos 
      subproject.name = this.subprojectName;
      subproject.userMembers = this.selectedInvitados;
      subproject.userOwner = [this.selectedEncargado];
      subproject.projectFrom = this.project._id;
      // subproject.image = this.imageBase64; // Agregar imagen en base64
      
      delete subproject._id;
      delete subproject.__v;
      delete subproject.createdAt;
      delete subproject.updatedAt;
      delete subproject.subprojectName;

      var subprojectId;

      // Mandar la request
      try {
        // console.log('subproyecto a mandar: ', subproject);
        const response = await api.post('/api/project/create', subproject);
        console.log(response);

        if ([200, 201].includes(response.status)) {
          console.log('Subproyecto creado:', response.data);
          subprojectId = response.data._id;

          // Emitir evento de nuevo subproyecto al servidor WebSocket
          this.$socket.emit('event_new_subproject', {
            room: this.project._id,
            subproject: response.data,
          });

          this.$store.commit('setSnackbar', {
            text: `${this.project.subprojectName} creado/a exitosamente!`,
            color: 'success',
            icon: 'mdi-check-circle',
          });
          this.$emit("update:dialog", false);  // Actualizar el prop desde el padre (cerrar modal)
        } else {
          this.$store.commit('setSnackbar', {
            text: "Error al crear el subproyecto",
            color: 'error',
            icon: 'mdi-alert-circle',
          });
        }
      } catch (error) {

        console.error("Error al crear el subproyecto:", error);
        this.$store.commit('setSnackbar',{
          text: "Error al crear el subproyecto",
          color: 'error',
          icon: 'mdi-alert-circle',
        });

      } finally {
        // Agregar el id del nuevo subproyecto a la lista de subproyectos
        api.post(`/api/project/${this.project._id}/add/subproject/${subprojectId}`)
      }

    },
  }
};
</script>